import * as util from "js-utils-julseb"
import { Avatar } from "fajny-react"

const allUtils = [
    {
        name: "allCities",
        effect: "JSON file with all cities and countries in the world",
    },
    {
        name: "calculateTotalSum",
        effect: "Calculates the total sum of an array of numbers",
        example: "calculateTotalSum([3, 30, 42, 2])",
        result: util.calculateTotalSum([3, 30, 42, 2]),
    },
    {
        name: "capitalize",
        effect: "Capitalizes the first letter of a string",
        example: 'capitalize("hello")',
        result: util.capitalize("hello"),
    },
    {
        name: "convertDate",
        effect: (
            <>
                Converts a date in the format <code>yyyy-mm-dd</code> to{" "}
                <code>dd fullMonth yyyy</code>
            </>
        ),
        example: 'convertDate("2022-01-28")',
        result: util.convertDate("2022-01-28"),
    },
    {
        name: "convertDateShort",
        effect: (
            <>
                Converts a date in the format <code>yyyy-mm-dd</code> to{" "}
                <code>dd shortMonth yyyy</code>
            </>
        ),
        example: 'convertDateShort("2022-01-28")',
        result: util.convertDateShort("2022-01-28"),
    },
    {
        name: "convertToEmail",
        effect: "Converts a string to an email address.",
        example: 'convertToEmail("Julien Sebag", "me.com")',
        result: util.convertToEmail("Julien Sebag", "me.com"),
    },
    {
        name: "convertToPascal",
        effect: "Converts a string to PascalCase",
        example: 'convertToPascal("hello world")',
        result: util.convertToPascal("hello world"),
    },
    {
        name: "convertYoutube",
        effect: "Converts a YouTube url to an embed link for iframes",
        example:
            'convertYoutube("https://www.youtube.com/watch?v=2EaxYi31ips")',
        result: util.convertYoutube(
            "https://www.youtube.com/watch?v=2EaxYi31ips"
        ),
    },
    {
        name: "convertPrice",
        effect: "Converts an amount to a formatted price",
        example: 'convertPrice(1000, "EUR")',
        result: util.convertPrice(1000, "EUR"),
    },
    {
        name: "detectLanguage",
        effect: (
            <>
                Search for <code>lang</code> or <code>language</code> in
                localStorage, and if it returns <code>null</code> both times
                detects the browser language
            </>
        ),
        example: "detectLanguage()",
        result: util.detectLanguage(),
    },
    {
        name: "getFirstName",
        effect: "Returns the first name of a string",
        example: 'getFirstName("Julien Sebag")',
        result: util.getFirstName("Julien Sebag"),
    },
    {
        name: "getLastName",
        effect: "Returns the last name of a string",
        example: 'getLastName("Julien Sebag")',
        result: util.getLastName("Julien Sebag"),
    },
    {
        name: "getRandom",
        effect: "Returns a random value inside an array",
        example: 'getRandom(["Hello", "world", "how", "are", "you"])',
        result: util.getRandom(["Hello", "world", "how", "are", "you"]),
    },
    {
        name: "getRandomAvatar",
        effect: (
            <>
                Returns a random avatar from{" "}
                <a
                    href="https://github.com/Ashwinvalento/cartoon-avatar"
                    target="_blank"
                    rel="noreferrer noopener"
                >
                    cartoon-avatar
                </a>{" "}
                library. Can be <code>male</code>, <code>female</code>, or{" "}
                <code>other</code> for random gender.
            </>
        ),
        example: 'getRandomAvatar("male")',
        result: <Avatar src={util.getRandomAvatar("male")} alt="Avatar" />,
    },
    {
        name: "getRandomCity",
        effect: "Returns a random city from a specified country",
        example: 'getRandomCity("France")',
        result: util.getRandomCity("France"),
    },
    {
        name: "getRandomDate",
        effect: "Returns a random date. You need to specify the minimum and maximum year",
        example: "getRandomDate(1970, 2022)",
        result: util.getRandomDate(1970, 2022),
    },
    {
        name: "getRandomLocation",
        effect: (
            <>
                Returns a random location from the <code>allCities</code> JSON
                file
            </>
        ),
        example: "getRandomLocation()",
        result: util.getRandomLocation(),
    },
    {
        name: "getRandomNumber",
        effect: "Returns a random number in a range. You need to specify the min and max",
        example: "getRandomNumber(1, 20)",
        result: util.getRandomNumber(1, 20),
    },
    {
        name: "getRandomString",
        effect: "Returns a random string of letters and numbers. You need to specify the length",
        example: "getRandomString(20)",
        result: util.getRandomString(20),
    },
    {
        name: "getRandomTime",
        effect: "Returns a random time. You need to specify the min hour and max hour.",
        example: "getRandomTime(0, 23)",
        result: util.getRandomTime(0, 23),
    },
    {
        name: "getTimeNow",
        effect: "Returns the time",
        example: "getTimeNow()",
        result: util.getTimeNow(),
    },
    {
        name: "getToday",
        effect: "Returns today's date",
        example: "getToday()",
        result: util.getToday(),
    },
    {
        name: "passwordRegex",
        effect: "Tests if a password contains at least 6 characters, one number, one uppercase letter and one lowercase letter",
        example: 'passwordRegex.test("Password42")',
        result: util.passwordRegex.test("Password42").toString(),
    },
    {
        name: "emailRegex",
        effect: "Tests if an email address is valid",
        example: 'emailRegex.test("a@b.c")',
        result: util.emailRegex.test("a@b.c").toString(),
    },
    {
        name: "scrollToTop",
        effect: "Function to scroll to the top of the page on click",
    },
    {
        name: "slugify",
        effect: "Replaces accents, spaces, uppercase letters, etc., in a string to convert it to a url friendly string",
        example: 'slugify("Hello world how are you?")',
        result: util.slugify("Hello world how are you?"),
    },
    {
        name: "stringifyPx",
        effect: "Returns a value in pixels if you enter a number",
        example: "stringifyPx(80)",
        result: util.stringifyPx(80),
    },
    {
        name: "unslugify",
        effect: "Replaces dashes and underscores to a space, and capitalize the first letter of a string",
        example: 'unslugify("hello-world-how-are-you")',
        result: util.unslugify("hello-world-how-are-you"),
    },
]

export default allUtils
